// add colors, fonts, fontSizes, space, etc
export default {};